import { useEffect, useRef } from 'react';

// A back navigation from an external page (Stripe Checkout) is served from the browser's
// bfcache, which restores this page with React state frozen exactly as it was when we
// redirected away. Nothing re-mounts and no state transition fires, so any flag that means
// "we are leaving" has to be released from the restore event itself.
export function usePageRestore(onRestore: () => void) {
    const callbackRef = useRef(onRestore);

    useEffect(() => {
        callbackRef.current = onRestore;
    });

    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) {
                callbackRef.current();
            }
        };

        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, []);
}
